import Button from "components/base/Button";
import Status from "components/base/Status";
import { useModals } from "ModalProvider";
import moment from "moment";
import ConfirmReviewView from "pages/suppliers/onboarding/ConfirmReviewView";

const ReviewStepView = ({
  supplierState,
  reviewId,
  step,
  index,
  isCurrentStep,
}) => {
  const modal = useModals();

  function confirmReview(result) {
    modal.present({
      title: "Confirm Review",
      children: (
        <ConfirmReviewView step={step} result={result} hide={modal.hide} />
      ),
    });
  }

  const completedAssignments = step.assignments.filter(
    (i) => i.result !== "PENDING",
  );

  return (
    <tr className="border-y border-gray-100 dark:border-gray-700">
      <td>
        <div className="flex items-center justify-between">
          <div>
            <div className="flex items-center space-x-2">
              <div className="font-semibold">
                {index + 1}. {step.name}
              </div>
            </div>
            {step.state === "PENDING" && (
              <div className="mt-1 text-xs">
                Required to confirm by:{" "}
                <b className="text-orange-600">
                  {step.assignments
                    .map((a) => a.user.firstName)
                    .join(` ${step.condition.toLowerCase()} `)}
                </b>
              </div>
            )}
          </div>
          {supplierState === "PENDING" && <Status status={step.state} />}
        </div>

        {supplierState === "PENDING" &&
          step.state === "PENDING" &&
          isCurrentStep && (
            <div className="flex space-x-4 mt-1">
              <Button onClick={() => confirmReview("ACCEPTED")}>Accept</Button>
              <Button danger onClick={() => confirmReview("REJECTED")}>
                Reject
              </Button>
            </div>
          )}

        {step.state !== "PENDING" && (
          <div className="mt-1 text-xs opacity-70">
            {completedAssignments.map((a, index) => (
              <div key={index}>
                <div className="space-x-1">
                  <span
                    className={`font-semibold capitalize ${
                      a.result === "ACCEPTED"
                        ? "text-green-600"
                        : a.result === "REJECTED"
                          ? "text-red-600"
                          : ""
                    }`}
                  >
                    {a.result.toLowerCase()}
                  </span>
                  <span>by</span>
                  <span className="font-semibold text-orange-600">
                    {a.user.firstName}
                  </span>
                  <span>at</span>
                  <span>{moment(a.updated_at).format("YYYY-MM-DD HH:mm")}</span>
                </div>
                {a.remark && (
                  <div className="whitespace-pre-wrap mt-1">{a.remark}</div>
                )}
              </div>
            ))}
          </div>
        )}
      </td>
    </tr>
  );
};

export default ReviewStepView;
